import Cookies from 'js-cookie';
// TODO: we should take it from the gcs
export const XSRF_TOKEN_COOKIE = 'XSRF-RLAC-TOKEN';
const XSRF_TOKEN_HEADER = 'X-XSRF-RLAC-TOKEN';
export const appendXsrfToken = (options) => appendAntiForgeryToken(options, XSRF_TOKEN_HEADER, XSRF_TOKEN_COOKIE);
const appendAntiForgeryToken = (options, headerName, cookieName) => ({
    ...options,
    headers: {
        ...options.headers,
        [headerName]: Cookies.get(cookieName) || '',
    },
});
export const onSuccess = (data) => {
    return {
        success: true,
        error: false,
        hasCompleteCV: data?.hasCompleteCV ?? true,
        statusCode: 200,
    };
};
export const onError = (statusCode) => {
    return {
        success: false,
        error: true,
        hasCompleteCV: true,
        statusCode: statusCode ?? 500,
    };
};
export const googleAuthReturnUrl = (currentLocale, redirectUrl, formType, loginSource, checkboxState) => `/${currentLocale}/candidate/google/success?formType=${formType}&googleAuthLoginSource=${loginSource}&checkboxState=${String(checkboxState)}&googleAuthRedirection=${redirectUrl}`;
//# sourceMappingURL=utils.js.map